// extracted by mini-css-extract-plugin
export default {"users":"Users_users__6Mzkx","base":"Users_base__BmH60","header":"Users_header__oy46Q","controls":"Users_controls__V6TYk"};